<template>
  <div class="ck-card">
    <div class="card-text">
      <div class="ck-card-title"><span class="column-count" v-show="columnCount">{{columnCount}}</span>{{ $t('ShippingMethods') }}</div>
      <div class="ck-edit-form">
        <b-form-group id="groupShippingMethods" label-for="shippingMethods">
          <b-form-radio-group
            id="shippingMethods"
            class="radio-block-response"
            v-validate="'required'"
            v-model="selected"
            :name="name"
          >
            <b-form-radio
              v-for="item in options"
              :key="item.carrier_code"
              :value="item.carrier_code"
              :class="[item.carrier_code]"
            >
            <div class="label-left">{{item.carrier_title}} – {{item.method_title}}</div><div class="label-right">{{item.amount.value | price($store)}}</div>
            </b-form-radio>
          </b-form-radio-group>
          <b-form-invalid-feedback :class="{ 'd-block': errors.has(name) }" class="position-relative">
            <span>{{ errors.first(name) }}</span>
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import Config from 'config'
import { EventBus, graphqlManageError } from '@/helpers'
import { toast } from 'theme/modules/notifications'
import Logger from '@/services/Logger'

export default {
  name: 'ShippingMethodsForm',
  props: {
    value: {
      type: Boolean,
      default: () => null
    },
    name: {
      type: String,
      default: () => 'shipping-method-form'
    },
    columnCount: {
      type: String
    },
    busListener: {
      type: String,
      required: false
    }
  },
  $_veeValidate: {
    validator: 'new',
    name () {
      return this.name
    }
  },
  data () {
    return {
      selected: null
    }
  },
  computed: {
    options () {
      if (this.$store.state.checkout.shippingMethods) {
        return this.$store.state.checkout.shippingMethods.filter(method => !Config.Theme.checkout.disabledShippingMethods.includes(method.method_code))
      } else {
        return []
      }
    }
  },
  methods: {
    edit (status) {
      this.editMode = status
    },
    goToEdit (status) {
      this.edit(status)
      EventBus.$emit('checkout:goto', 'shipping-methods-section')
    },
    confirmData () {
      // save shipping method
      return this.$validator.validateAll().then(isValid => {
        if (isValid) {
          const _this = this
          this.$store.commit('ui/showLoader')
          const shippingMethod = this.options.find((opt) => opt.carrier_code === this.selected)
          return this.$store.dispatch('checkout/setShippingMethods', {
            carrier_title: shippingMethod.carrier_title,
            carrier_code: shippingMethod.carrier_code,
            method_code: shippingMethod.method_code,
            method_title: shippingMethod.method_title,
            amount: shippingMethod.amount.value
          })
            .then(() => {
              _this.editMode = false
              EventBus.$emit('checkout:updResume')
              _this.$emit('next-step')
            })
            .catch(error => {
              const msg = graphqlManageError(error) ? _this.$t(graphqlManageError(error)) : _this.$t('GenericError')
              toast.error(msg)
              Logger.error('error save shipping method ', error)
            })
            .finally(() => {
              _this.$store.commit('ui/hideLoader')
            })
        }
      })
    },
    init () {
      let firstOptionCarrier = this.options && this.options.length ? this.options[0].carrier_code : ''
      this.setShippingMethod({ carrierCode: this.$store.state.checkout.shippingMethod || firstOptionCarrier })
      EventBus.$on('fakeChoice:isPickupEnable', this.setShippingMethod)
    },
    setShippingMethod (payload) {
      this.selected = payload.carrierCode
    }
  },
  mounted () {
    this.init()
    if (this.busListener) {
      EventBus.$on(`${this.busListener}:validateForm`, this.confirmData)
    }
  },
  destroyed () {
    if (this.busListener) {
      EventBus.$off(`${this.busListener}:validateForm`, this.confirmData)
    }
    EventBus.$off('fakeChoice:isPickupEnable', this.setShippingMethod)
  }
}
</script>
